export const hasPermission = (
  user_permissions: any,
  module_permission: any,
) => {
  return module_permission?.every(
    (item: any) => user_permissions?.includes(item),
  );
};
